
import { ElMessage } from "element-plus";
import { getEnum } from "@/api/index";
import { useRouter ,useRoute } from "vue-router";
import {
  getAllPosts,
  getAllDepart,
  getAllRole,
  putUser, getUserDetail
} from "@/api/backstage";
import type { ElForm } from "element-plus";
import Uploadimg from "@/components/uploadimg/Index.vue";
import { useStore } from "vuex";
type FormInstance = InstanceType<typeof ElForm>;
 
import { putParameter, updParametert } from "@/api/backstage";
import {
  defineComponent,
  reactive,
  computed,
  ref,
  unref,
  toRefs,
  watch,
  onMounted,
} from "vue";
export default defineComponent({
  name: "新增用户",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  components: {
    Uploadimg,
  },
  emits: ["close"],
  setup(opt, contex) {
    const store = useStore();
    let isEdit = false;
    let show = opt.open;
    const router = useRouter();
    const route = useRoute();
    const dataMap: any = reactive({
      ruleFormRef: ref<FormInstance>(),
      sex: {},
      roles: [],
      posts: [],
      depart: [],
      ruleForm: {
        realName: "",
        departId: "",
        gender: "",
        roleId: "",
        status: true,
        telephone: "",
        birthday: "",
        description: "",
        email: "",
        fileId: "",
        idCard: "",
        password: "",
        postId: "",
        staffNo: "",
        username: "",
      },
      rules: {
        realName: [
          { required: true, message: "请输用户姓名", trigger: "blur" },
        ],
        departId: [
          { required: true, message: "请选择所属部门", trigger: "blur" },
        ],
        roleId: [
          { required: true, message: "请选择所属角色", trigger: "blur" },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        telephone: [
          {
            pattern: /^0?1(3|4|5|7|8)\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            pattern:
              /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: "请输入正确的身份证号码",
            trigger: "blur",
          },
        ],
      },

      async getSex() {
        dataMap.menuClass = {};
        const menus = await getEnum("SEX");
        for (const item of menus.data) {
          dataMap.sex[item.enumKey] = item;
        }
      },

      async getDepart() {
        const res = await getAllDepart();
        dataMap.depart = res?.data ?? [];
      },

      async getRole() {
        const res = await getAllRole();
        dataMap.roles = res?.data ?? [];
      },
      async getPost() {
        const res = await getAllPosts();
        dataMap.posts = res?.data ?? [];
      },

      async getUser() {
        const res = await getUserDetail(route.query.id);
        dataMap.ruleForm = res.data;
        dataMap.ruleForm.status ==='STATUS_YES'? dataMap.ruleForm.status= true: dataMap.ruleForm.status= false;
        dataMap.ruleForm.fileUrl?  dataMap.ruleForm.fileUrl =  localStorage.getItem("fileUrel") +dataMap.ruleForm.fileUrl :'';
        dataMap.ruleForm.password? dataMap.ruleForm.password='000000':'';
      },

      async putUser() {
        let query: any = JSON.parse(JSON.stringify(dataMap.ruleForm));
        query.status ? (query.status = "STATUS_YES"): (query.status = "STATUS_NO");
        const res = await putUser(query);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
         router.go(-1);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
      async updParametert() {
        let query: any = JSON.parse(JSON.stringify(dataMap.ruleForm));
        query.status ? (query.status = "STATUS_YES"): (query.status = "STATUS_NO");
        const res = await updParametert(query);
        if (res.code === 200) {
          ElMessage({
            message: "操作成功",
            type: "success",
          });
           router.go(-1);
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      },
    });

    if (opt.row) {
      isEdit = true;
      dataMap.ruleForm = opt.row;
    }

    const onSuccess = (val: any) => {
      dataMap.ruleForm.fileId = val.id;
    };

    const submitForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.validate((valid) => {
        if (valid) {
          dataMap.isEdit ? dataMap.putUser() : dataMap.putUser();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };

    onMounted(() => {
     if (route.query.id) dataMap.getUser();
      dataMap.getSex();
      dataMap.getDepart();
      dataMap.getPost();
      dataMap.getRole();
    });

    return {
      show,
      store,
      isEdit,
      router,
      submitForm,
      close,
      route,
      onSuccess,
      ...toRefs(dataMap),
    };
  },
});
